<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton" [disabled]=vb.disabled></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Navigation</ion-title>
        @if (!vb.disabled) {
  <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
}
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-list-header color="secondary">
        Shuttle Selection - (Step 1 of 5)
    </ion-list-header>

    <ion-list>
        <ion-radio-group data-test="shuttleSection">
            @for (shuttle of vm.shuttles; track $index) {
  <ion-item [disabled]=vb.disabled>
                <ion-label class="ion-text-wrap">
                    <span class="line1">{{shuttle.shuttleName}}</span><br />
                    <span class="line2">Passenger Capacity: {{shuttle.passengerCapacity}}</span>
                </ion-label>
                <ion-radio (click)="onShuttleClick(shuttle)"></ion-radio>
            </ion-item>
}
        </ion-radio-group>
    </ion-list>

    @if (vm.shuttles?.length === 0) {
  <div class="ion-padding">
        <p class="infoMsg">No routes defined. Go to Routes and then click the + icon to define a route.</p>
    </div>
}
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]="vb.disabled || !vm.step1Complete" title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>

